import { cdnService, ImageFormat, ImageFit, RoutablePage, scroll, waitForImage, MagicConfigMixin, ContentMixin } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __decorate, __metadata } from 'tslib';
import { Vue, Prop, Watch, Emit, Component, Mixins } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { magic } from '@gig/magic-sdk';
import { OFFER_NAMESPACE } from '../../store/modules/offer/offer.store.js';
import { store } from '../../store/index.js';
import { CtaStyle } from '@gig/magic-sdk/dist/util/interfaces';

var offers = namespace(OFFER_NAMESPACE);
/**
 * Component displaying full page offer
 */
var OfferComponent = /** @class */ (function (_super) {
    __extends(OfferComponent, _super);
    function OfferComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(OfferComponent.prototype, "offer", {
        get: function () {
            return this.getOffer(this.slug, this.magicConfig.language);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OfferComponent.prototype, "background", {
        get: function () {
            if (!this.offer || !this.offer.background) {
                return '';
            }
            return cdnService.getOfferBackgroundUrl(this.offer.background, {
                width: 1.0,
                height: 1.0,
                format: ImageFormat.WEBP,
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OfferComponent.prototype, "src", {
        get: function () {
            return this.getImage(ImageFormat.WEBP);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OfferComponent.prototype, "avifSrcset", {
        get: function () {
            return this.getImageSrcset(ImageFormat.AVIF);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OfferComponent.prototype, "webpSrcset", {
        get: function () {
            return this.getImageSrcset(ImageFormat.WEBP);
        },
        enumerable: false,
        configurable: true
    });
    OfferComponent.prototype.getImageSrcset = function (format) {
        var _this = this;
        if (!this.offer || !this.offer.image) {
            return null;
        }
        return this.widths
            .map(function (width) { return _this.getImage(format, width) + " " + width + "w"; })
            .join(', ');
    };
    OfferComponent.prototype.getImage = function (format, width) {
        if (width === void 0) { width = 1.0; }
        if (!this.offer || !this.offer.image) {
            return null;
        }
        return cdnService.getPromotionImageUrl(this.offer.image, {
            width: width,
            fit: ImageFit.MAX,
            format: format,
        });
    };
    OfferComponent.prototype.loadOffer = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        this.onContentLoadInit();
                        return [4 /*yield*/, this.fetchOffer({
                                slug: this.slug,
                                lang: this.magicConfig.language,
                            })];
                    case 1:
                        _a.sent();
                        this.onContentLoad(this.offer);
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        console.error('Offer error:', e_1);
                        this.onContentLoadError(e_1);
                        this.routeTo({ route: RoutablePage.NOT_FOUND });
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    OfferComponent.prototype.onOfferLoad = function () {
        return __awaiter(this, void 0, void 0, function () {
            var user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        user = magic.session.getUser();
                        if (this.offer && this.offer.authRequired && !user) {
                            this.routeTo({ route: RoutablePage.HOME });
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, Vue.nextTick()];
                    case 1:
                        _a.sent();
                        if (!this.showTerms || !this.$refs.terms) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, waitForImage(this.$refs.header)];
                    case 2:
                        _a.sent();
                        scroll.scrollTo(this.$refs.terms);
                        return [2 /*return*/];
                }
            });
        });
    };
    OfferComponent.prototype.onCtaClick = function (cta) {
        var user = magic.session.getUser();
        if (cta.style === CtaStyle.OPTIN && user) {
            magic.methods.offers.optIn(this.slug, this.magicConfig.language, cta.text, user.userName);
        }
    };
    /**
     * Emitted when offer was successfully loaded
     */
    OfferComponent.prototype.onContentLoad = function (offer) {
        return offer;
    };
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], OfferComponent.prototype, "slug", void 0);
    __decorate([
        Prop(Array),
        __metadata("design:type", Array)
    ], OfferComponent.prototype, "widths", void 0);
    __decorate([
        Prop({ type: Boolean, default: false }),
        __metadata("design:type", Boolean)
    ], OfferComponent.prototype, "showTerms", void 0);
    __decorate([
        offers.Getter('getOffer'),
        __metadata("design:type", Function)
    ], OfferComponent.prototype, "getOffer", void 0);
    __decorate([
        offers.Action('fetchOffer'),
        __metadata("design:type", Function)
    ], OfferComponent.prototype, "fetchOffer", void 0);
    __decorate([
        Watch('magicConfig.language'),
        Watch('slug', { immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], OfferComponent.prototype, "loadOffer", null);
    __decorate([
        Watch('offer', { immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], OfferComponent.prototype, "onOfferLoad", null);
    __decorate([
        Emit('contentLoad'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], OfferComponent.prototype, "onContentLoad", null);
    OfferComponent = __decorate([
        Component({
            name: 'offer',
            store: store,
        })
    ], OfferComponent);
    return OfferComponent;
}(Mixins(MagicConfigMixin, ContentMixin)));

export default OfferComponent;
